import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/axios'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
import './plugins/vue-world-map'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import './registerServiceWorker'

Vue.config.productionTip = false

/* router.beforeEach((to, from, next) => {
  if (!localStorage.chaveFuncionarioMobile && to.path !== '/cadastro') {
    next('/cadastro')
  } else if (localStorage.chaveFuncionarioMobile && !localStorage.senhaFuncionarioMobile && to.path !== '/ativacao') {
    next('/ativacao')
  } else {
    next()
  }
}) */

/* var config = {
  apiKey: '<API_KEY>',
  authDomain: '<DOMAIN>',
  databaseURL: '<DATABASE_URL>',
  projectId: '<PROJECT_ID>',
  storageBucket: '<STORAGE_BUCKET>',
  messagingSenderId: '<SENDER_ID>'
};
firebase.initializeApp(config);

Vue.prototype.$messaging = firebase.messaging()

navigator.serviceWorker.register('/firebase-messaging-sw.js')
  .then((registration) => {
    Vue.prototype.$messaging.useServiceWorker(registration)
  }).catch(err => {
    console.log(err)
  }) */

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
